import '../App.css';
import { Header, Button, Container, Segment, Divider, Icon } from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import { List } from 'semantic-ui-react';
import { db } from "../utils/firebase";
import { ref, onValue } from "firebase/database";
import ReplyForm from '../components/ReplyForm';
import { useNavigate } from 'react-router-dom';


function MyMessagesOverviewPage({ channel, senderId }) {
  const [selectedSender, setSelectedSender] = useState(null);
  const [chatContent, setChatContent] = useState(null);
  const [senders, setSenders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [])

  useEffect(() => {
    if (senderId) {
      onSenderClick(senderId);
    }
  }, [senderId]);

  useEffect(() => {
    const onPopState = (event) => {
      if (event.state?.chatId) {
        // ak ideme späť z detailu iného chatu, otvoríme ho
        setSelectedSender(event.state.chatId.split('_')[1]); // dostaneme meno druhej osoby
      } else {
        // ak nie je chatId, ideme späť na zoznam
        setSelectedSender(null);
        setChatContent(null);
      }
    };

    window.addEventListener('popstate', onPopState);

    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const getData = () => {
    const data = ref(db, 'chatLinks/' + channel)

    onValue(data, (snapshot) => {
      if (snapshot.val()) {
        const newSenders = Object.keys((snapshot.val()));
        setSenders(Object.keys((snapshot.val())))
      }
    })
  }

  const onSenderClick = (sndr) => {
    setSelectedSender(sndr);

    //get chatId
    const chatIdArray = [channel, sndr]
    chatIdArray.sort();
    const chatId = chatIdArray[0] + "_" + chatIdArray[1];

    const data = ref(db, 'chats/' + chatId)

    onValue(data, (snapshot) => {
      if (snapshot.val()) {
        setChatContent(snapshot.val());
      }
    })

    navigate(`#chat-${sndr}`, { state: { chatId } });
  }


  const showDate = (timestamp) => {
    const d = new Date(parseInt(timestamp));
    const year = d.getFullYear() // 2019
    const day = d.getDate() // 23    
    const month = d.getMonth() + 1 // 23    
    const hh = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
    const mn = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
    return `${day}.${month}.${year} ${hh}:${mn}`
  }

  const renderSendersOverview = () => {
    return <Segment>
      <div className="standardMargin" textAlign='left'>
        <Header size='small'>Konverzácie s:</Header>
        <List divided relaxed style={{ minHeight: '15vh', maxHeight: '30vh', overflow: 'auto', }}>
          {!senders || !senders.length > 0 ? "...prázdne..." :
            senders.map(sender => {
              return <List.Item className="hoverable-item" style={{ padding: '0.5rem' }} onClick={() => onSenderClick(sender)}>
                <List.Content>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Icon color="grey" name="envelope outline"></Icon>
                    <List.Header>{sender}</List.Header>
                  </div>
                </List.Content>
              </List.Item>
            })
          }
        </List>
      </div>
    </Segment>
  }

  const renderChat = () => {
    if (!chatContent) {
      return <></>
    }

    return <Segment>
      <div className="standardMargin" textAlign='left'>
        <Header size='small' style={{ textAlign: 'center' }}>Konverzácia s {selectedSender}</Header>
        <Divider />
        <List divided relaxed style={{ minHeight: '15vh', maxHeight: '30vh', overflow: 'auto', paddingRight: '5px' }}>
          {!chatContent || !Object.keys(chatContent).length > 0 ? "...prázdne..." :
            Object.keys(chatContent).map(timestamp => {
              const msg = chatContent[timestamp];
              return <List.Item className="hoverable-item">
                <List.Content>
                  <List.Header className={msg?.aliasB === selectedSender ? 'alignLeft' : 'alignRight'}>{msg.content}</List.Header>
                  <List.Description className={msg?.aliasB === selectedSender ? 'alignLeft' : 'alignRight'} style={{ fontSize: '0.8em' }}>{showDate(timestamp)}</List.Description>
                </List.Content>
              </List.Item>
            })
          }
        </List>
        <ReplyForm sender={selectedSender} owner={channel} />
        <Container>
          <Button style={{ marginTop: '1rem' }} icon='back' onClick={() => setSelectedSender()}>SPÄŤ</Button>
        </Container>
      </div>
    </Segment>
  }

  return (
    <Container style={{ background: 'white', borderRadius: '10px', border: 'solid white', width: '85vw !important' }} textAlign='center'>
      <Container className="standardMargin">
        <Header size='medium'>{channel}</Header>
      </Container>
      {<>
        {!selectedSender ? renderSendersOverview() : renderChat()}
      </>}
    </Container>
  );
}

export default MyMessagesOverviewPage;
